export default __webpack_public_path__ + "static/ios-c79aced2503a1216d930cf64b8775c35.png";